export const PORTAL_REJECT_TAG_LABELS = {
  too_expensive: 'Too expensive',
  not_accurate: 'Not accurate',
};

export const PORTAL_QUERY_REASON_LABELS = {
  price: 'Pricing',
  accuracy: 'Accuracy / details',
  timing: 'Timing / scheduling',
  scope: 'Scope of work',
  other: 'Other',
};

export function labelPortalRejectTags(tags) {
  if (!Array.isArray(tags) || tags.length === 0) return [];
  return tags.map((t) => PORTAL_REJECT_TAG_LABELS[t] || t);
}

export function portalFeedbackActionLabel(action) {
  switch (action) {
    case 'accepted':
      return 'Accepted';
    case 'rejected':
      return 'Declined';
    case 'queried':
      return 'Query / changes requested';
    default:
      return 'Client response';
  }
}
